<button class="btn btn-lg btn-flat" (click)="openHistory()" [disabled]="!hasHistory">
  <em class="icon">visibility</em>
</button>
